"use client";
import {
  BackgroundTextureLines
} from "./chunk-FCO34OXZ.mjs";
import {
  CardProvider
} from "./chunk-CXFPQ4YY.mjs";
import {
  useCard
} from "./chunk-HAHGAQLN.mjs";
import {
  forwardRef
} from "./chunk-5OS2BYH5.mjs";

// src/card.tsx
import { Ripple } from "@kirvanobr/ripple";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Card = forwardRef((props, ref) => {
  const {
    children,
    context,
    Component,
    ripples,
    isPressable,
    disableAnimation,
    disableRipple,
    getCardProps,
    getTextureProps,
    getTextureContainerProps,
    texture
  } = useCard({
    ...props,
    ref
  });
  const backgroundTexture = useMemo(() => {
    return /* @__PURE__ */ jsx("div", { ...getTextureContainerProps(), children: texture === "lines" && /* @__PURE__ */ jsx(BackgroundTextureLines, { ...getTextureProps() }) });
  }, [texture]);
  return /* @__PURE__ */ jsxs(Component, { ...getCardProps(), children: [
    backgroundTexture,
    /* @__PURE__ */ jsx(CardProvider, { value: context, children }),
    isPressable && !disableAnimation && !disableRipple && /* @__PURE__ */ jsx(Ripple, { ripples })
  ] });
});
Card.displayName = "UI.Card";
var card_default = Card;

export {
  card_default
};
